"use client";

import { SessionProvider } from "next-auth/react";
import type { Session } from "next-auth";
import { DebugModeProvider } from "@/components/debug/DebugModeContext";

export default function Providers({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) {
  return (
    <SessionProvider
      session={session}
      refetchOnWindowFocus={false}
      refetchWhenOffline={false}
    >
      <DebugModeProvider>{children}</DebugModeProvider>
    </SessionProvider>
  );
}
